import axios from 'axios';
import { Message } from 'element-ui'
import { getCookie } from '@/utils/util.js';
import router from '@/router'

/**
 * axios实例
 */
const request = axios.create({
  baseURL: process.env.ONE_baseURL,
  timeout: 10000,
  headers: {
    
  }
});

/**
 * 请求前添加token
 */
request.interceptors.request.use(function(config) {
  config.headers['Authorization'] = getCookie('token') !== '' ? 'Bearer ' + getCookie('token') : ''; // 获取token 也就是说在设置的时候也要设置成token
  return config;
});
export default request;
/**
 * 请求回来处理数据
 */
request.interceptors.response.use(function(res) {
  if (res.config.url.indexOf('getQrCode') !== -1) {
    return res.request.response
  }
  if(res.config.url.indexOf('/company/suncode') !== -1){
    return res.request.response
    // return Promise.reject(res.request.response)
  }
  var result = JSON.parse(res.request.response);
  if (result.isSuccess) {
    return result;
  } else {
    Message({
      message: result.message ? result.message : result.errmsg,
      type: 'warning'
    });
    if (result.code === 401) {
      // if (!result.isSuccess || result.code === 401) {
      // router.push({path: '/login'})
    }
    return Promise.reject(result);
  }
},err => {
  //==============  HTTP错误处理  ====================
  if (err && err.response) {
    switch (err.response.status) {
      case 400:
        err.message = '请求错误(400)';
        break;
      case 401:
        err.message = '未授权，请重新登录(401)';
        break;
      case 403:
        err.message = '拒绝访问(403)';
        break;
      case 404:
        err.message = '请求出错(404)';
        break;
      case 408:
        err.message = '请求超时(408)';
        break;
      case 500:
        err.message = '服务器错误(500)';
        break;
      case 501:
        err.message = '服务未实现(501)';
        break;
      case 502:
        err.message = '网络错误(502)';
        break;
      case 503:
        err.message = '服务不可用(503)';
        break;
      case 504:
        err.message = '网络超时(504)';
        break;
      case 505:
        err.message = 'HTTP版本不受支持(505)';
        break;
      default:
        err.message = `连接出错(${err.response.status})!`;
    }
  } else {
    err.message = '连接服务器失败!'
    router.push({path: '/login'})
  }
  Message({
    message: err.message,
    type: 'warning'
  });
  return Promise.resolve(err);
}

)



// WEBPACK FOOTER //
// ./src/utils/request.js